import { writable } from "svelte/store";

const initialState = {
  list: [],
};
const { subscribe, update, set } = writable(initialState);
/**
 * update the state
 * @param {Array} arr
 */

const updateState = (arr) =>
  update((oldState) => {
    let newList = oldState.list;
    if (Array.isArray(arr)) {
      newList = [...newList, ...arr];
    }
    return {
      list: newList,
    };
  });
/**
 * set the state
 * @param {Array} arr
 * @returns
 */
const setState = (arr) =>
  set({
    list: arr,
  });
const togglePostLike = (action, index) => {
  update((oldState) => {
    const List = oldState.list;
    List[index] = {
      ...List[index],
      lc: parseInt(List[index].lc) + (action ? 1 : -1),
      pl: action ? 1 : 0,
    };
    return {
      list: List,
    };
  });
};

export default {
  subscribe,
  updateState,
  setState,
  togglePostLike,
};
